import { Toaster as Sonner } from 'sonner'

type ToasterProps = React.ComponentProps<typeof Sonner>

const EpicToaster = ({ theme, ...props }: ToasterProps) => {
	return (
		<Sonner
			theme={theme}
			className="toaster group"
			toastOptions={{
				// Note: do NOT name this marker class "toast" — daisyui ships its own
				// `.toast` component (position: fixed; background-color: transparent;
				// width: max-content), which collides with sonner's own toast item and
				// strips its background/box entirely, leaving bare unstyled text.
				classNames: {
					toast:
						'group sonner-toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg',
					description:
						'group-[.sonner-toast]:text-muted-foreground group-[.sonner-toast]:break-words',
					actionButton:
						'group-[.sonner-toast]:bg-primary group-[.sonner-toast]:text-primary-foreground',
					cancelButton:
						'group-[.sonner-toast]:bg-muted group-[.sonner-toast]:text-muted-foreground',
				},
			}}
			{...props}
		/>
	)
}

export { EpicToaster }
